export const openAccount = [
  {
    path: "/openAccount/applyFor",
    name: "ApplyFor",
    component: () =>
      import("@/views/accountOpenManagement/accountOpenApply/index.vue"),
    meta: {
      title: "开户申请",
      icon: "menu_circle",
      activeMenu: "/openAccount/applyFor",
      menuId: "noPermission",
      grade: 1,
      hidden: false,
    },
  },
  {
    path: "/openAccount/batchOpenAccount",
    name: "batchOpenAccount",
    component: () =>
      import(
        "@/views/accountOpenManagement/accountOpenApply/batchOpenApply.vue"
      ),
    meta: {
      title: "批量开户",
      icon: "menu_circle",
      activeMenu: "/openAccount/applyFor",
      menuId: "noPermission",
      grade: 2,
      hidden: true,
      oneTitle: "开户申请",
    },
  },
  {
    path: "/openAccount/historyList",
    name: "HistoryList",
    component: () =>
      import("@/views/accountOpenManagement/accountOpenReport/index.vue"),
    meta: {
      title: "开户记录",
      icon: "menu_circle",
      activeMenu: "/openAccount/historyList",
      menuId: "1861283974680621142",
      hidden: false,
    },
  },
  {
    path: "/openAccount/body",
    name: "Body",
    component: () =>
      import("@/views/accountOpenManagement/accountOpenMain/index.vue"),
    meta: {
      title: "开户主体",
      icon: "menu_circle",
      activeMenu: "/openAccount/body",
      menuId: "1861283974680621142",
      hidden: false,
    },
  },
];
// 按钮code映射
export const productsBtnMap = {
  productExport_76426757: "1861283974676426757", // 商品管理-导出
};
